import runnersService from '../../api/runners'
import moment from 'moment'

const state = {
  all: [],
  totalPages: 0,
  totalRunners: 0
}

const getters = {
  allRunners (state) {
    return state.all
  },
  totalPages (state) {
    return state.totalPages
  },
  totalRunners (state) {
    return state.totalRunners
  }
}

const actions = {
  async getAllRunners ({ commit }, data) {
    
    const runnersResponse = await runnersService.getAll(data.page, data.search)
    const runners = runnersResponse.content

    commit('setRunners', runners)
    commit('setTotalPages', runnersResponse.totalPages)
    commit('setTotalRunners', runnersResponse.totalElements)
    
  },
  async getAllWithRunCompleted ({ commit }, page) {
    
    const runnersResponse = await runnersService.getAllWithRunCompleted(page)
    const runners = runnersResponse.content

    commit('setRunners', runners)
    commit('setTotalPages', runnersResponse.totalPages)
    commit('setTotalRunners', runnersResponse.totalElements)
    
  },
  async deactivate ({ commit }, runnerId) {
    

    let runnerForUpdate = await runnersService.getRunner(runnerId)

    let newDataRunner = {
      ...runnerForUpdate,
      name: 'Deactivated',
      user: {
        ...runnerForUpdate.user,
        email: `deactivated+${runnerForUpdate.user.id}@deacivated.com`,
        login: `deactivated+${runnerForUpdate.user.id}@deacivated.com`,
        password: 'deactivated'
      }
    }

    const updated = await runnersService.updateRunner(newDataRunner)

    if (updated) {
      const runnersResponse = await runnersService.getAll(0, '')
      const runners = runnersResponse.content

      commit('setRunners', runners)
      commit('setTotalPages', runnersResponse.totalPages)
      commit('setTotalRunners', runnersResponse.totalElements)

      

      return true
    }
  },
  clearAllRunners ({ commit }) {
    commit('setTotalPages', 0)
    commit('setRunners', [])
  }
}

const mutations = {
  setRunners (state, runners) {
    state.all = runners.reduce((runners, runner) => {
      runner.accountCreate = moment(runner.accountCreate).format('YYYY/MM/DD HH:mm')

      if (runner.membershipStartDate) {
        runner.membershipStartDate = moment(runner.membershipStartDate).format('YYYY/MM/DD')
      }

      if (runner.membershipEndDate) {
        runner.membershipEndDate = moment(runner.membershipEndDate).format('YYYY/MM/DD')
      }

      if (runner.lastLiveRun) {
        runner.lastLiveRun = moment(runner.lastLiveRun).format('YYYY/MM/DD')
      }

      runners.push(runner)

      return runners
    }, [])
  },
  setTotalPages (state, totalPages) {
    state.totalPages = totalPages
  },
  setTotalRunners (state, totalRunners) {
    state.totalRunners = totalRunners
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/runners.js